import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { collection, getDocs, orderBy, query } from 'firebase/firestore'
import { httpsCallable } from 'firebase/functions'
import { db, functions } from '@/lib/firebase'

export interface RepositoryCatalogItem {
  id: string; name: string; full_name: string; owner: string; html_url: string
  description: string | null; default_branch: string; private: boolean; archived: boolean
  pushed_at: string; last_synced_at: string
}

export function useRepositoryCatalog() {
  return useQuery({
    queryKey: ['repository_catalog'],
    queryFn: async () => {
      const snap = await getDocs(query(collection(db, 'repository_catalog'), orderBy('full_name')))
      return snap.docs.map(d => ({ id: d.id, ...(d.data() as Omit<RepositoryCatalogItem, 'id'>) }))
    },
  })
}

export function useRefreshRepositoryCatalog() {
  const client = useQueryClient()
  const fn = httpsCallable<unknown, { ok: boolean; count: number; synced_at: string }>(functions, 'refreshRepositoryCatalog')
  return useMutation({
    mutationFn: async () => (await fn()).data,
    onSuccess: () => client.invalidateQueries({ queryKey: ['repository_catalog'] }),
  })
}
